<template>
    <div class="columns is-multiline is-centered has-text-centered">
        <div class="column is-full has-text-centered">
            <b-field :type="barrioRaw ? 'is-success' : 'is-danger'" size="is-large" class="has-text-centered">
                <template #label>
                     <p class="has-text-weight-bold"> <b-icon icon="map-marker-alt" size="is-small" type="is-success"></b-icon> Elige tu barrio para ver los dias disponibles</p>
                </template>
                <b-select expanded v-model="barrioRaw" @input="barrioChange">
                    <option value="1-Canelones:_Carmel"> Canelones: CARMEL</option>
                    <option value="1-Canelones:_Ciudad_de_la_costa"> Canelones: CIUDAD DE LA COSTA</option>
                    <option value="1-Canelones:_La_asuncion"> Canelones: LA ASUNCION</option>
                    <option value="1-Canelones:_La_tahona"> Canelones: LA TAHONA</option>
                    <option value="1-Canelones:_Parque_miramar"> Canelones: PARQUE MIRAMAR</option>
                    <option value="1-Canelones:_San_nicolas"> Canelones: SAN NICOLAS</option>
                    <option value="1-Canelones:_Zona_franca"> Canelones: ZONA FRANCA</option>
                    <option value="2-Montevideo:_Aguada"> Montevideo: AGUADA</option>
                    <option value="1-Montevideo:_Aires_puros"> Montevideo: AIRES PUROS</option>
                    <option value="2-Montevideo:_Arroyo_seco"> Montevideo: ARROYO SECO</option>
                    <option value="1-Montevideo:_Atahualpa"> Montevideo: ATAHUALPA</option>
                    <option value="2-Montevideo:_Barrio_sur"> Montevideo: BARRIO SUR</option>
                    <option value="3-Montevideo:_Bella_vista"> Montevideo: BELLA VISTA</option>
                    <option value="4-Montevideo:_Belvedere"> Montevideo: BELVEDERE</option>
                    <option value="1-Montevideo:_Brazo_oriental"> Montevideo: BRAZO ORIENTAL</option>
                    <option value="1-Montevideo:_Buceo"> Montevideo: BUCEO</option>
                    <option value="3-Montevideo:_Capurro"> Montevideo: CAPURRO</option>
                    <option value="1-Montevideo:_Carrasco_norte"> Montevideo: CARRASCO NORTE</option>
                    <option value="1-Montevideo:_Carrasco"> Montevideo: CARRASCO</option>
                    <option value="2-Montevideo:_Centro"> Montevideo: CENTRO</option>
                    <option value="1-Montevideo:_Cerrito_de_la_victoria"> Montevideo: CERRITO DE LA VICTORIA</option>
                    <option value="4-Montevideo:_Cerro"> Montevideo: CERRO</option>
                    <option value="2-Montevideo:_Ciudad_vieja"> Montevideo: CIUDAD VIEJA</option>
                    <option value="4-Montevideo:_Colon"> Montevideo: COLÓN</option>
                    <option value="4-Montevideo:_Conciliacion"> Montevideo: CONCILIACIÓN</option>
                    <option value="2-Montevideo:_Cordon"> Montevideo: CORDÓN</option>
                    <option value="1-Montevideo:_Flor_de_maronas"> Montevideo: FLOR DE MAROÑAS</option>
                    <option value="2-Montevideo:_Goes"> Montevideo: GOES</option>
                    <option value="1-Montevideo:_Ituzaingo"> Montevideo: ITUZANGÓ</option>
                    <option value="1-Montevideo:_Jacinto_vera"> Montevideo: JACINTO VERA</option>
                    <option value="1-Montevideo:_Jardines_de_carrasco"> Montevideo: JARDINES DE CARRASCO</option>
                    <option value="1-Montevideo:_Jardines_del_hipodromo"> Montevideo: JARDINES DEL HIPÓDROMO</option>
                    <option value="1-Montevideo:_La_blanqueada"> Montevideo: LA BLANQUEADA</option>
                    <option value="2-Montevideo:_La_comercial"> Montevideo: LA COMERCIAL</option>
                    <option value="1-Montevideo:_La_figurita"> Montevideo: LA FIGURITA</option>
                    <option value="4-Montevideo:_La_teja"> Montevideo: LA TEJA</option>
                    <option value="1-Montevideo:_Larranaga"> Montevideo: LARRAÑAGA</option>
                    <option value="1-Montevideo:_Las_acacias"> Montevideo: LAS ACACIAS</option>
                    <option value="1-Montevideo:_Las_canteras"> Montevideo: LAS CANTERAS</option>
                    <option value="4-Montevideo:_Lavalleja"> Montevideo: LAVALLEJA</option>
                    <option value="1-Montevideo:_Malvin_norte"> Montevideo: MALVÍN NORTE</option>
                    <option value="1-Montevideo:_Malvin_nuevo"> Montevideo: MALVÍN NUEVO</option>
                    <option value="1-Montevideo:_Malvin"> Montevideo: MALVÍN</option>
                    <option value="1-Montevideo:_Maronas"> Montevideo: MAROÑAS</option>
                    <option value="1-Montevideo:_Mercado_modelo"> Montevideo: MERCADO MODELO</option>
                    <option value="4-Montevideo:_Nuevo_paris"> Montevideo: NUEVO PARÍS</option>
                    <option value="2-Montevideo:_Palermo"> Montevideo: PALERMO</option>
                    <option value="1-Montevideo:_Parque_batlle"> Montevideo: PARQUE BATLLE</option>
                    <option value="1-Montevideo:_Parque_rodo"> Montevideo: PARQUE RODÓ</option>
                    <option value="1-Montevideo:_Perez_castellanos"> Montevideo: PEREZ CASTELLANOS</option>
                    <option value="4-Montevideo:_Penarol"> Montevideo: PEÑAROL</option>
                    <option value="1-Montevideo:_Pocitos"> Montevideo: POCITOS</option>
                    <option value="1-Montevideo:_Porvenir"> Montevideo: PORVENIR</option>
                    <option value="3-Montevideo:_Prado"> Montevideo: PRADO</option>
                    <option value="2-Montevideo:_Puerto"> Montevideo: PUERTO</option>
                    <option value="1-Montevideo:_Punta_carretas"> Montevideo: PUNTA CARRETAS</option>
                    <option value="1-Montevideo:_Punta_gorda"> Montevideo: PUNTA GORDA</option>
                    <option value="2-Montevideo:_Reducto"> Montevideo: REDUCTO</option>
                    <option value="4-Montevideo:_Sayago"> Montevideo: SAYAGO</option>
                    <option value="2-Montevideo:_Tres_cruces"> Montevideo: TRES CRUCES</option>
                    <option value="1-Montevideo:_Union"> Montevideo: UNIÓN</option>
                    <option value="1-Montevideo:_Villa_dolores"> Montevideo: VILLA DOLORES</option>
                    <option value="1-Montevideo:_Villa_espanola"> Montevideo: VILLA ESPAÑOLA</option>
                    <option value="2-Montevideo:_Villa_munoz"> Montevideo: VILLA MUÑOZ</option>		
                </b-select>
            </b-field>
        </div>
        <div class="column is-half has-text-left">
            <b-field label="Fecha de entrega*">
                <b-datepicker
                    inline
                    v-model="date"
                    locale="es-ES"
                    :years-range="yearsRange"
                    :unselectable-days-of-week="unselectableDays"
                    :min-date="minDateAlgo"
                    :max-date="maxDateAlgo"
                    :disabled="disabledDate"
                    placeholder="Click para seleccionar"
                    icon="calendar-today"
                    trap-focus>
                </b-datepicker>
            </b-field>
            
        </div>
        <div class="column is-half has-text-left">
            <b-field label="Horario preferido para recibir*">
                <b-select 
                v-model="scheduledTime" 
                @input="selectedTime" 
                :disabled="disabledTime"
                :placeholder="disabledTime ? 'Elige fecha primero' : 'Selecciona uno'"
                >
                    <option value="morning">De 8 a 13 hs.</option>
                    <option v-if="dayOfWeek != 6" value="afternoon">De 13 a 18 hs.</option>
                </b-select>
            </b-field>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            date:"",
            barrio:"",
            barrioName:"",
            barrioRaw:"",
            yearsRange:[0,0],
            maxDaysInFuture:30,
            scheduledTime:''
        }
    },
    methods:{
        selectedTime(){
            if (this.scheduledTime == "morning"){
                this.date.setHours(8)
            } 
            else if (this.scheduledTime == "afternoon"){
                this.date.setHours(13)
            }
            this.$emit("dateDone", {date:this.date, barrio:this.barrioName})
        },
        barrioChange(){
            this.date = ""
            this.scheduledTime = ""
            var barrioSections = this.barrioRaw.split("-")
            this.barrio = barrioSections[0]
            this.barrioName = barrioSections[1].replace(/_/gi, " ")
        }
    },
    computed:{
        unselectableDays(){
            if (this.barrio == '1'){
                return [0, 1, 3, 5]
            }
            else if(this.barrio == '2') {
                return [0, 2, 4]
            }
            else if(this.barrio == '3') {
                return [0, 2, 4]
            }
            else if(this.barrio == '4') {
                return [0, 2, 4]
            }
        },

        minDateAlgo(){
            var now = new Date()
            now.setDate(now.getDate() + 1);
            if (now.getDay() == 0 || now.getDay() == 6){
                now.setDate(now.getDate() + 1);
            }
            return now
        },
        maxDateAlgo(){
            var now = new Date()
            

            var limit = new Date("02/08/2022")
            var days = limit.getTime() - now.getTime()
            days = days / (1000 * 3600 * 24);
            console.log("asdsadasd", days)
            console.log("yyyyyyyyyy", now)
            if(days > this.maxDaysInFuture){
                now.setDate(now.getDate() + this.maxDaysInFuture)
            } else if (days <= 0){
                return now
            } else {
                now.setDate(now.getDate() + days)
            }
            console.log("yyyyyyyyyy", now)

            return now
        },
        disabledTime(){
            if (this.date == ''){
                return true
            }
            return false
        },
        disabledDate(){
            if(this.barrio == ''){
                return true
            }
            return false
        },
        dayOfWeek(){
            if (this.date){
                return this.date.getDay()
            } else{
                return 0
            }
        }
         
    }
}
</script>